<template>
    <div class="carousel-wrapper">
        <div class="carousel-container">
            <div class="carousel--nav__left-container">
                <div class="carousel--nav__left-label">
                    <div class="label">GAME VIDEOS</div>
                </div>
                <div class="carousel--nav__left-button" @click="moveCarousel(1)">
                    <div class="carousel--nav__left" :disabled="atHeadOfList"></div>
                </div>
            </div>
            <div class="carousel">
                <div class="carousel--overflow-container">
                    <div
                        class="carousel-cards" ref="container"
                        :style="{ transform: 'translateX' + '(' + currentOffset + 'px' + ')'}"
                        @wheel.prevent="onScroll"
                    >
                        <CarouselItem
                            v-for="item in streams.data"
                            :key="item.id"
                            :item="item"
                            :activePlaybackId="activePlaybackId"
                            @click="setActive"
                        >
                            <div class="label-bar" v-if="item.type === 'player-highlight'">
                                <PlayerHighlightLabels :item="item"/>
                            </div>
                            <div class="label-bar" v-else>
                                <DefaultLabels :item="item"/>
                            </div>
                        </CarouselItem>
                    </div>
                </div>
            </div>
            <div class="carousel--nav__right-container">
                <div class="carousel--nav__right-button" @click="moveCarousel(-1)">
                    <div class="carousel--nav__right" :disabled="atEndOfList"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* global dataLayer */
import { createNamespacedHelpers } from 'vuex';
import * as types from '../../../store/actionTypes';
import CarouselItem from './CarouselItem';
import PlayerHighlightLabels from './PlayerHighlightLabels';
import DefaultLabels from './DefaultLabels';

const { mapState, mapActions } = createNamespacedHelpers('main');

export default {
    name: 'Carousel',
    components: {
        CarouselItem,
        PlayerHighlightLabels,
        DefaultLabels
    },
    data() {
        return {
            currentOffset: 0,
            paginationFactor: 217,
            containerWidth: 0
        }
    },
    mounted() {
        window.addEventListener('resize', this.handleWindowSizeChange);
        this.containerWidth = this.$refs.container.offsetWidth;
    },
    updated() {
        this.containerWidth = this.$refs.container.offsetWidth;
    },
    destroyed() {
        window.removeEventListener('resize', this.handleWindowSizeChange);
    },
    methods: {
        ...mapActions({
            changeActivePlayback: types.CHANGE_ACTIVE_PLAYBACK
        }),
        moveCarousel(direction) {
            if (direction === -1 && !this.atEndOfList) {
                dataLayer.push({ event: 'Carousel scroll' });
                if ((this.streams.data.length - (Math.abs(this.currentOffset / this.paginationFactor) + this.containerWidth / this.paginationFactor)) < 1) {
                    this.currentOffset -= (1 - (this.containerWidth / this.paginationFactor) % 1) * this.paginationFactor
                } else {
                    this.currentOffset -= this.paginationFactor;
                }
            } else if (direction === 1 && !this.atHeadOfList) {
                dataLayer.push({ event: 'Carousel scroll' });
                if (this.currentOffset > -this.paginationFactor) {
                    this.currentOffset = 0;
                } else {
                    this.currentOffset += this.paginationFactor;
                }
            }
        },
        setActive(id) {

            /** do the active playback mutation only when click was on the different item **/
            if (this.activePlaybackId !== id) {
                this.changeActivePlayback(id);
            }
        },
        onScroll(e) {
            const direction = Math.sign(e.wheelDelta);
            this.moveCarousel(direction)
        },
        handleWindowSizeChange() {
            this.containerWidth = this.$refs.container.offsetWidth;
            this.currentOffset = 0;
        }
    },
    computed: {
        ...mapState({
            streams: state => state.video.streams,
            activePlaybackId: state => state.video.activePlaybackId
        }),
        atEndOfList() {
            return +this.currentOffset.toFixed() <= +((this.paginationFactor * -1) * (this.streams.data.length - ((this.containerWidth) / this.paginationFactor))).toFixed();
        },
        atHeadOfList() {
            return this.currentOffset === 0;
        }
    }
}
</script>
